
    // import Navbar from "./Navbar";
    
    const HeroSection = () => {
      return (
        <section className="hero">
        <div className="content">
          <div className="title">
            <h1>The hard days are the best</h1>
            <h1>Because</h1>
            <h1>thats when champions are made.</h1>
          </div>
          <div className="sub-title">
            <p>Working out isnt just good for your body <br /> 
              Your Journey to Fitness Starts Here..!</p>
          </div>
          <div className="buttons">
            <button id="btn-1">Start Your Journey</button>
            <button>Discover Your Plan</button>
          </div>
        </div>
      </section>
      );
    };
    
    export default HeroSection;
